import type { FC } from 'react';
import { Badge } from '@interstate/components/Badge';

/**
 * Badge displayed when a field has been updated
 */
export const UpdatedBadge: FC = () => <Badge variant="dark">Updated</Badge>;
